import { render, staticRenderFns } from "./AuthenticationLogs.vue?vue&type=template&id=4b888f42&"
import script from "./AuthenticationLogs.vue?vue&type=script&lang=js&"
export * from "./AuthenticationLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports